<template>
  <li class="profile-nav" :class="{ active: isActive }" @click="ck()">
    <a href="javascript:void(0);" class="profile-nav-link">
      <slot name="icon"></slot>
      <slot name="txt"></slot>
    </a>
  </li>
</template>

<script>
export default {
  props: {
    isActive: { Type: Boolean },
  },
  data() {
    return {};
  },
  methods: {
    ck() {
      this.$emit("ck");
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/profileNavItem.vue